import { createContext, useContext, useEffect, useState } from "react";
import { T } from "@/content";

const LangContext = createContext(null);

export const LangProvider = ({ children }) => {
  const [lang, setLang] = useState(() => {
    const saved = typeof window !== "undefined" ? window.localStorage.getItem("ogen-lang") : null;
    return T[saved] ? saved : "en";
  });
  const dir = lang === "he" ? "rtl" : "ltr";

  useEffect(() => {
    document.documentElement.lang = lang;
    document.documentElement.dir = dir;
    window.localStorage.setItem("ogen-lang", lang);
  }, [lang, dir]);

  return <LangContext.Provider value={{ lang, setLang, dir, t: T[lang] }}>{children}</LangContext.Provider>;
};

export const useLang = () => useContext(LangContext);
